export default  ({palette}) => ({
    containerForm: {
        maxWidth: 611,
        margin: 'auto'
    },

    paymentDeviceSubtitle: {
        color: palette.grey['600'],
        lineHeight: 1,
        height: '100%',

        "@media all and (max-width: 600px)": {
            textAlign: 'center'
        }
    },

    paymentMeanLogoContainer: {
        margin: 0,
        textAlign: 'right',

        "@media all and (max-width: 600px)": {
            margin: '14px 0 20px 0',
            textAlign: 'center'
        }
    },

    paymentMeanLogo: {
        height: 50,
        "@media all and (max-width: 600px)": {
            textAlign: 'center',
        }
    },

    subtitle: {
        fontSize: "1.2rem",
        color: palette.subtitle
    }
})